import gql from 'graphql-tag';
import apolloClient from '../../../../utils/apolloClient';

const UPDATE_INVOICE_STATUS = gql`
  mutation UpdateInvoiceStatus($input: UpdateInvoiceStatusInput) {
    update_invoice_status(input: $input) {
      updated_ids
      status
      error {
        code
        description
      }
    }
  }
`;

const isAppError = err =>
  typeof err === 'object' && err !== null && 'code' in err && 'message' in err;

const toAppError = err => {
  if (err instanceof Error) {
    const msg = err.message.toLowerCase();
    if (msg.includes('unauthorized') || msg.includes('unauthenticated'))
      return { message: err.message, code: 'UNAUTHORIZED' };
    if (msg.includes('network') || msg.includes('failed to fetch'))
      return { message: err.message, code: 'NETWORK_ERROR' };
    return { message: err.message, code: 'UNKNOWN_ERROR' };
  }
  return { message: 'An unexpected error occurred', code: 'UNKNOWN_ERROR' };
};

export async function updateInvoiceStatus(
  params,
  client = apolloClient.clientPrivate,
) {
  const { userId, companyInvoiceId, status } = params;

  try {
    const { data } = await client.mutate({
      mutation: UPDATE_INVOICE_STATUS,
      variables: {
        input: {
          user_id: userId,
          company_invoice_id: Array.isArray(companyInvoiceId) ? companyInvoiceId : [companyInvoiceId],
          status,
        },
      },
    });

    const result = data?.update_invoice_status;

    if (!result) {
      throw {
        message: 'No data returned from update_invoice_status',
        code: 'PARSE_ERROR',
      };
    }

    if (result.error?.length) {
      throw {
        message: result.error[0]?.description ?? 'API error',
        code: 'API_ERROR',
      };
    }

    return {
      updatedIds: result.updated_ids,
      status: result.status,
    };
  } catch (err) {
    if (isAppError(err)) throw err;
    throw toAppError(err);
  }
}

export const updateInvoiceStatusService = { updateInvoiceStatus };
